import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  isFormLoaded: false,
  isCaptured: false,
  error: null,
  listingCannotBeActivated: false,
});

const reducer = (state = initState(), action) => {
  switch (action.type) {
    case DispatchConstants.LISTING_CANNOT_BE_ACTIVATED:
      return { ...state, listingCannotBeActivated: true, error: action.payload };
    case DispatchConstants.START_PAYMENT_METHOD_SESSION_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case DispatchConstants.CREDIT_CARD_FORM_LOAD_COMPLETE:
      return { ...state, isFormLoaded: action.payload };
    case DispatchConstants.CREDIT_CARD_FORM_SUBMIT_SUCCESS:
      return { ...state, error: null };
    case DispatchConstants.VERIFY_CREDIT_CARD_CAPTURE_SUCCESS:
      return { ...state, isCaptured: true };
    case DispatchConstants.INITIATE_CREDIT_CARD_CAPTURE_FAIL:
    case DispatchConstants.CREDIT_CARD_FORM_SUBMIT_FAIL:
      return { ...state, error: action.payload };
    case DispatchConstants.RESET_CREDIT_CARD_CAPTURE_POST_PAYMENT:
      return { ...state, isCaptured: false };
    default:
  }
  return state;
};

export default reducer;
